import React, { FC, ReactNode } from "react"
import Sidebar from "../Components/layout/Sidebar"
import Header from "../Components/layout/Header"

interface MainLayoutProps {
  children: ReactNode
  activeSidebarTab?: string
  sidebarTotalBookings?: number
  sidebarCallScheduled?: number
  headerTitle?: string
  headerBreadcrumb?: string
  onSearch?: (value: string) => void
  onCreateNew?: () => void
  showSearch?: boolean
}

const MainLayout: FC<MainLayoutProps> = ({
  children,
  activeSidebarTab = 'all',
  sidebarTotalBookings = 0,
  sidebarCallScheduled = 0,
  headerTitle = "予約申請一覧",
  headerBreadcrumb = "ホーム / 予約管理 / 一覧",
  onSearch,
  onCreateNew,
  showSearch = false
}) => {
  return (
    <div className="flex min-h-screen">
      <Sidebar 
        activeTab={activeSidebarTab}
        totalBookings={sidebarTotalBookings}
        callScheduled={sidebarCallScheduled}
      />
      
      <div className="flex-1 ml-[280px] flex flex-col min-h-screen">
        <Header 
          title={headerTitle}
          breadcrumb={headerBreadcrumb}
          onSearch={onSearch}
          onCreateNew={onCreateNew}
          showSearch={showSearch}
        />
        
        <main className="flex-1 p-8 bg-gray-50/50">
          {children}
        </main>
      </div>
    </div>
  )
}

export default MainLayout

